import * as yup from 'yup';
import { useField, useForm } from 'vee-validate';

const MESSAGES = {
	requiredLength: 'Введите длину',
	requiredWidth: 'Введите ширину',
	requiredHeight: 'Введите высоту',
	requiredWeight: 'Введите вес',
	requiredCount: 'Введите количество мест'
};

const numberRule = (msg: string) =>
	yup.number().positive(msg).required(msg).typeError(msg);

const validationSchema = yup.object({
	length: numberRule(MESSAGES.requiredLength),
	width: numberRule(MESSAGES.requiredWidth),
	height: numberRule(MESSAGES.requiredHeight),
	weight: numberRule(MESSAGES.requiredWeight),
	count: numberRule(MESSAGES.requiredCount)
});

export function useCalcForm() {
	const { validate } = useForm({ validationSchema });

	const lengthField = useField<number | undefined>('length', { value: '' });
	const widthField = useField<number | undefined>('width');
	const heightField = useField<number | undefined>('height');
	const weightField = useField<number | undefined>('weight');
	const countField = useField<number | undefined>('count');

	return {
		validate,
		lengthField,
		widthField,
		heightField,
		weightField,
		countField
	};
}
